var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _circle, _circle2, _path73, _circle3, _circle4, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcReviewing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1476,
    height: 773,
    viewBox: "0 0 1476 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.884 500.021C451.11 506.574 489.079 510.498 508.733 500.021C540.239 483.224 546.794 378.424 550.447 355.047",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1128 571C1069.82 539.579 1015.5 487.097 1001.72 446.058C995.31 424.255 979.671 395.399 1004.78 367.185C1029.89 338.97 1053 359.276 1061.42 372.956C1073.9 392.822 1108.69 437.099 1142 460.577",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.23 583.347C1365.23 596.15 1356.84 629.827 1371.23 662.111",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.03 421.509C1319.62 406.365 1342.97 431.958 1358.68 444.047C1386.29 468.226 1444.52 524.441 1461.44 553.455C1468.7 562.724 1497.11 606.045 1416.71 664.678",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.04 674C1447.99 684.949 1463.31 708.878 1429 717",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1437 697C1435.03 687.209 1426.91 668.744 1409.41 662.814C1406.53 661.84 1403.4 661.204 1400 661",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.24 590C1379.43 604.556 1356.65 658.379 1389.29 695.145C1421.93 731.911 1434.7 735.134 1437 732.15",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1313 518C1322.77 536.2 1352.45 573.08 1393 575",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M977.033 371.171C966.907 351.468 935.957 336.212 929.785 331.233C921.478 324.532 923.641 319.882 927.102 318.685C931.141 317.488 938.986 319.044 944.986 325.267C950.985 331.489 954.408 329.056 955.369 327.062C955.755 326.064 956.293 321.437 955.369 310.906C954.447 300.376 937.487 294.154 937.487 286.973C937.487 278.836 943.64 279.594 946.716 280.99C952.486 283.583 964.6 290.922 966.907 299.538C967.458 303.344 969.784 312.148 974.682 316.91",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M983.829 311.372C982.003 305.838 976.832 295.348 967.52 300.545",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M993.34 314.089C993.34 309.824 993.82 301.41 979.751 301.875",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.45 339.912C1010.87 334.033 1004.58 325.54 1003.19 316.394C1002.23 310.101 995.045 305.725 990.625 305.943",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M693.061 344.001L666.217 448.181C665.615 450.518 668.901 451.724 669.954 449.553L720.469 345.373C721.113 344.045 720.145 342.5 718.669 342.5H694.998C694.086 342.5 693.289 343.118 693.061 344.001Z",
    fill: "#21325B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M501.966 342.5H624.063C626.293 342.5 628.253 343.977 628.868 346.121L658.497 449.322C659.916 454.268 666.98 454.103 668.167 449.096L692.536 346.347C693.07 344.092 695.084 342.5 697.401 342.5H890.304",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M615.33 172.743H1008.73C1011.49 172.743 1013.73 174.982 1013.73 177.743V296.345",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M533.969 174.102H409.855C407.093 174.102 404.855 176.34 404.855 179.102V336.27C404.855 339.032 407.093 341.27 409.855 341.27H471.368",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M514.942 169.563C520.936 156.732 542.685 129.314 577.489 139.711C602.302 147.123 615.419 170.141 617.826 185.959C618.35 189.407 614.832 191.445 611.909 189.542C606.027 185.713 598.098 179.453 591.562 171.134",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M539.405 172.743C545.134 192.011 560.209 231.861 570.651 226.64C576.901 223.515 571.172 197.478 565.964 188.365",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M573.383 217.394C582.53 224.453 596.251 221.316 577.956 178.179",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M588.332 211.56C595.961 214.135 607.133 209.705 590.784 171.383",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M473.237 292.158C470.534 291.709 474.049 275.884 476.434 266.892C476.644 266.099 476.354 265.261 475.697 264.769L461.93 254.46C460.476 253.371 461.108 251.063 462.915 250.869C468.861 250.231 476.532 249.405 479.743 249.049C485.066 248.458 485.657 236.647 489.206 231.923C491.849 228.405 495.721 238.258 497.675 244.718C497.924 245.541 498.656 246.125 499.514 246.168L517.085 247.045C518.84 247.133 519.641 249.281 518.377 250.501C513.738 254.983 507.625 260.996 505.767 263.222C502.81 266.765 512.865 285.072 514.047 292.158C515.23 299.245 493.346 279.757 492.163 277.985C490.981 276.214 476.786 292.749 473.237 292.158Z",
    fill: "#21325B",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M620.46 248.895L603.025 250.442C602.08 250.525 601.209 249.936 600.914 249.035C599.676 245.248 597.307 238.862 594.817 234.814C592.114 230.419 587.434 242.905 585.06 250.885C584.805 251.743 584.023 252.336 583.128 252.363C579.715 252.464 573.592 252.895 567.876 254.09C559.494 255.843 573.264 263.436 578.053 268.109C582.843 272.782 569.073 285.048 572.066 292.058C575.06 299.067 589.429 281.544 593.021 279.207C596.613 276.871 609.785 291.474 615.173 292.058C620.562 292.642 612.18 273.366 609.785 268.109C608.338 264.932 615.453 258.001 621.946 252.701C623.523 251.414 622.488 248.715 620.46 248.895Z",
    fill: "#21325B",
    fillOpacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M827.044 248.895L809.608 250.442C808.664 250.525 807.793 249.936 807.498 249.035C806.26 245.248 803.89 238.862 801.401 234.814C798.698 230.419 794.018 242.905 791.644 250.885C791.389 251.743 790.607 252.336 789.711 252.363C786.299 252.464 780.176 252.895 774.459 254.09C766.078 255.843 779.848 263.436 784.637 268.109C789.427 272.782 775.657 285.048 778.65 292.058C781.644 299.067 796.013 281.544 799.605 279.207C803.197 276.871 816.369 291.474 821.757 292.058C827.145 292.642 818.764 273.366 816.369 268.109C814.922 264.932 822.037 258.001 828.53 252.701C830.106 251.414 829.072 248.715 827.044 248.895Z",
    fill: "#21325B",
    fillOpacity: 0.8
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M728.804 249.692C733.632 244.631 717.329 246.445 707.251 248.197C706.327 248.358 705.41 247.866 705.079 246.989C703.237 242.117 702.519 237.56 699.894 231.505C696.939 224.691 692.376 240.186 690.403 249.783C690.2 250.77 689.313 251.466 688.307 251.421C684.309 251.243 677.656 251.094 673.295 251.51C666.935 252.116 676.765 260.603 683.125 266.665C689.485 272.727 679.077 280.607 678.499 293.338C677.921 306.068 691.22 287.882 697.58 283.032C703.941 278.183 707.988 293.338 714.927 293.338C721.866 293.338 714.927 276.364 713.192 270.302C711.458 264.24 722.444 256.36 728.804 249.692Z",
    fill: "#21325B",
    fillOpacity: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M940.09 267.6C947.248 264.266 928.758 258.669 918.618 256.287C919.016 252.318 919.692 242.711 919.215 236.042C918.618 227.706 906.689 246.165 903.707 249.737C900.725 253.31 887.603 245.57 879.253 244.379C870.902 243.188 883.428 256.287 888.796 262.837C894.164 269.387 879.253 276.532 877.463 286.654C875.674 296.777 892.375 284.868 899.532 284.273C906.689 283.677 901.918 297.967 911.461 305.708C921.004 313.449 918.618 290.822 918.618 281.295C918.618 271.768 931.144 271.768 940.09 267.6Z",
    fill: "#21325B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M941.697 223.031L945.775 206.722",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M948.493 233.903C954.263 230.414 968.321 222.541 978.393 218.953",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M958.007 242.058L974.316 246.135",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M276.956 546.495H998.779",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3 546.495H172.488",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 546.494V335.884C24.7461 327.6 31.4618 320.884 39.7461 320.884H122.601",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M707.477 694.503C698.591 679.495 726.956 677.306 742.25 678.088V688.875L791.994 694.503C767.524 700.756 716.363 709.511 707.477 694.503Z",
    fill: "#21325B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M813.911 673.567L796.378 694.023",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M791.994 635.579L743.778 632.657",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M762.772 619.507L813.911 620.968",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M743.778 632.657L740.856 686.717",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M813.911 622.429V673.567",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M796.378 653.112V694.023",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M743.778 632.657L762.772 619.507",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M796.378 694.023L739.395 686.717",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M496.854 758.827C497.329 745.937 550.458 750.08 553.779 750.54V758.827L569.907 769.875C545.398 770.489 496.475 769.139 496.854 758.827Z",
    fill: "#21325B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M628.351 758.311V708.634",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M587.44 770V715.939",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M552.374 758.311V704.25",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M552.374 704.251L590.362 694.023",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M628.351 708.634L587.44 715.939",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M587.44 770L628.351 758.311",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M628.351 708.634L590.362 694.023",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M552.374 704.25L587.44 715.939",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M369.739 653.628C370.222 640.737 424.414 644.881 427.801 645.341V653.628L444.252 664.676C419.253 665.29 369.351 663.94 369.739 653.628Z",
    fill: "#21325B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M502.696 653.112V604.896",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M460.324 664.801V612.201",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M426.719 653.112V599.051",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M460.324 664.801L502.696 653.112",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M502.696 604.896L460.324 612.201",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M426.719 599.051L463.247 590.285",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M502.696 604.896L463.247 590.285",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M426.719 600.512L460.325 612.201",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M486.539 555.114L466.029 587.241C465.347 588.309 465.818 589.734 467.002 590.186L500.141 602.831C501.054 603.18 502.084 602.817 502.579 601.975L521.941 568.97C522.572 567.895 522.077 566.512 520.907 566.081L488.915 554.313C488.033 553.989 487.044 554.322 486.539 555.114Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.11 223.965C1143.27 264.122 1148.87 267.68 1165.11 285.47C1165.11 267.889 1168.14 238.377 1168.14 226.087C1221.36 226.087 1266.26 204.347 1282.08 193.475C1281.51 230.341 1316.05 254.446 1316.05 254.446C1316.05 254.446 1311.1 269.335 1308.26 302.656C1305.99 329.314 1312.52 324.163 1316.05 318.254C1326.24 285.357 1342.93 294.149 1350.02 302.656C1436.86 161.443 1303.31 134.158 1277.83 136.758C1258.58 120.31 1231.74 107.42 1212.87 105.529C1144.79 98.7109 1113.99 158.853 1132.11 223.965Z",
    fill: "#21325B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1316 344.405C1306.7 400.481 1244.33 440.805 1199.31 395.378C1154.29 349.952 1163.31 266.802 1168.11 228",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1349.26 297C1354.39 311.304 1349.57 343 1316 343",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.7 308C1334.66 310.475 1333.89 316.343 1323 320",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1169 337C1156.94 332.016 1148.43 313.558 1151.71 284",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1236 371.23C1224.79 374.884 1225.5 364.826 1217 356",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.5 305C1196.81 305 1193 301.642 1193 297.5C1193 293.358 1196.81 290 1201.5 290C1206.19 290 1210 293.358 1210 297.5C1210 301.642 1206.19 305 1201.5 305Z",
    fill: "#21325B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1268 305C1263.58 305 1260 302.314 1260 299C1260 295.686 1263.58 293 1268 293C1272.42 293 1276 295.686 1276 299C1276 302.314 1272.42 305 1268 305Z",
    fill: "#21325B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1286 282C1284.22 277.775 1276.51 269.96 1260 272.495",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1214 272C1210.21 270.491 1199.91 268.378 1189 272",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.04 297C1242.42 306.873 1243.38 326.898 1236 328",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.36 434.41C1188.95 419.747 1193.9 409.88 1198.7 408C1227.64 432.815 1271.54 423.603 1287.8 408.563C1293.59 413.527 1290.22 428.208 1287.8 432.719C1256.46 465.204 1211.84 447.007 1194.36 434.41Z",
    fill: "#21325B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1192 433C1167.01 439.064 1123.08 486.064 1157.92 668",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370.467,
    cy: 149.763,
    r: 31.8359,
    stroke: "#21325B",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.567,
    cy: 149.763,
    r: 31.8359,
    stroke: "#21325B",
    strokeWidth: 5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M325.903 143.483C328.826 141.93 335.547 139.987 339.053 144.649",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.028,
    cy: 152.685,
    r: 8.03605,
    fill: "#21325B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.622,
    cy: 152.685,
    r: 8.03605,
    fill: "#21325B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M358.047 134.421C360.264 132.863 366.582 129.512 374.119 128.577",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M287.915 129.053C294.611 127.687 304.352 129.053 309.831 135.882",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M330.287 175.318C334.522 175.5 343.373 174.005 344.898 166.565",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M309.831 201.632C315.743 208.302 315.58 214.305 336.131 207.19",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M380.589 179.715C383.318 194.627 380.221 208.775 358.371 230.261C333.229 254.983 321.535 267.344 286.454 240.856",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M382.685 197.248C375.19 101.581 306.607 62.9644 272.45 55.381C252.307 58.6476 241.403 112.945 216.032 118.896C208.492 118.896 201.562 117.408 198.123 102.035C179.854 20.3677 233.609 17.0752 257.226 19.7974C393.072 -56.0351 465.832 103.914 382.685 197.248Z",
    fill: "#21325B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M211.938 156.338C211.938 157.799 211.938 161.306 211.938 163.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M260.154 141.727H211.938",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M218.542 145.474C210.329 139.698 196.397 144.268 201.25 166.104C204.276 179.72 218.11 181.645 220.704 173.118",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M233.854 261.537C111.126 261.537 110.774 413.572 48.2942 474.858",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M345.099 374.413C322.134 380.861 282.439 377.201 266.467 374.279C265.766 374.151 265.147 374.76 265.269 375.461C268.13 391.944 277.45 471.201 275.616 542.698C275.604 543.184 275.938 543.607 276.417 543.692C284.562 545.133 306.727 546.634 318.906 544.603C319.276 544.542 319.569 544.274 319.677 543.916L324.826 526.96C332.748 509.001 340.887 445.88 346.386 375.47C346.441 374.767 345.778 374.222 345.099 374.413Z",
    fill: "#21325B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M350.332 252.771C354.863 302.379 343.5 477 320.5 543.5",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M244.082 287.837C255.785 330.74 281.245 452.681 275.5 545.5",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M248.465 279.07C258.788 302.818 291.574 342.632 305.448 356.509",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M315.676 356.508C324.23 338.331 342.926 297.687 349.281 280.531",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M319.02 363.083C319.02 367.92 315.4 371.542 311.292 371.542C307.184 371.542 303.564 367.92 303.564 363.083C303.564 358.247 307.184 354.625 311.292 354.625C315.4 354.625 319.02 358.247 319.02 363.083Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M183.141 530.379C183.141 531.178 197.372 544.212 199.875 551.626C200.802 554.373 200.12 556.348 196.506 556.644C185.814 557.52 173.116 541.688 168.104 533.663",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M198.78 521.613C203.911 529.514 212.86 541.692 220.704 548.6C219.988 553.91 214.606 561.98 198.806 551.786C196.399 544.592 182.715 531.945 182.715 531.17",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M212.924 514.308C222.892 524.689 240.979 546.931 233.585 552.843C232.274 553.891 230.602 553.993 228.691 553.379C226.415 552.647 223.799 550.901 221.049 548.529C213.084 541.662 203.997 529.554 198.787 521.698",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M133.038 533.947C149.67 513.49 201.375 476.412 231.747 503.262C243.86 515.134 258.956 536.593 250.278 545.36C245.939 548.648 236.547 544.264 230.49 535.497",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M404.803 368.197C399.87 390.484 387.997 438.927 379.964 454.402",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M404.803 432.486C413.171 411.681 429.204 366.189 426.393 350.664",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M360.97 257.884C371.441 259.102 394.429 262.998 402.611 268.843",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcReviewing);
export default __webpack_public_path__ + "static/media/oc-reviewing.7d42a0465ce29e86f0d3244b832341f7.svg";
export { ForwardRef as ReactComponent };